import { render, staticRenderFns } from "./rmPlsc.vue?vue&type=template&id=25b4500b"
import script from "./rmPlsc.vue?vue&type=script&lang=js"
export * from "./rmPlsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports